if (!customElements.get('medical-device-consent')) {
  class MedicalDeviceConsent extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('.js-medical-device-consent-checkbox');
      this.box = this.querySelector('.medical-device-consent__box');
      this.errorEl = this.querySelector('.js-medical-device-consent-error');
      this.section = this.closest('.js-product');
      const productFormEl = this.section?.querySelector('product-form');
      this.submitBtn = productFormEl?.querySelector('[name="add"]');
      this.form = this.section?.querySelector('.js-product-form-main');
      this.dynamicCheckout = this.section?.querySelector('.product-info__dynamic-checkout-button');
      this.variants = this.getVariantData();

      if (!this.checkbox || !this.submitBtn || !this.form) {
        this.remove();
        return;
      }

      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleAddButtonClick = this.handleAddButtonClick.bind(this);

      this.checkbox.addEventListener('change', () => {
        if (this.checkbox.checked) {
          this.hideError();
        }
        this.updateBoxState();
        this.applyButtonState(this.getCurrentVariant());
      });

      this.form.addEventListener('submit', this.handleSubmit, true);
      this.submitBtn.addEventListener('click', this.handleAddButtonClick, true);

      const variantPicker = this.section?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', (evt) => {
          if (evt.detail.variant) {
            this.checkbox.checked = false;
            this.hideError();
            this.updateBoxState();
            this.applyButtonState(evt.detail.variant);
          } else {
            this.hidden = true;
            if (this.dynamicCheckout) this.dynamicCheckout.hidden = false;
          }
        });
      }

      this.updateBoxState();
      this.applyButtonState(this.getCurrentVariant());
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.handleSubmit, true);
      this.submitBtn?.removeEventListener('click', this.handleAddButtonClick, true);
    }

    updateBoxState() {
      if (!this.box) return;
      this.box.classList.toggle('is-checked', this.checkbox.checked);
    }

    /**
     * @returns {object[]}
     */
    getVariantData() {
      const dataEl = this.querySelector('script[type="application/json"]');
      if (!dataEl) return [];
      try {
        return JSON.parse(dataEl.textContent).variants || [];
      } catch {
        return [];
      }
    }

    /**
     * @returns {?object}
     */
    getCurrentVariant() {
      const input = this.form.querySelector('[name="id"]');
      if (!input) return null;
      const variantId = parseInt(input.value, 10);
      return this.variants.find((variant) => variant.id === variantId) || null;
    }

    /**
     * @param {?object} variant
     */
    applyButtonState(variant) {
      if (!variant) {
        this.hidden = true;
        if (this.dynamicCheckout) this.dynamicCheckout.hidden = false;
        return;
      }

      this.hidden = false;
      if (this.dynamicCheckout) this.dynamicCheckout.hidden = true;

      const consentGiven = this.checkbox.checked;

      if (!variant.available) {
        this.submitBtn.disabled = true;
        this.submitBtn.removeAttribute('aria-disabled');
      } else if (!consentGiven) {
        this.submitBtn.disabled = false;
        this.submitBtn.setAttribute('aria-disabled', 'true');
      } else {
        this.submitBtn.disabled = false;
        this.submitBtn.removeAttribute('aria-disabled');
      }
    }

    /**
     * @returns {boolean}
     */
    requiresConsent() {
      const variant = this.getCurrentVariant();
      return Boolean(variant?.available && !this.checkbox.checked);
    }

    showError() {
      const message = theme.strings.medicalDeviceConsentAcceptConditions || 'Accetta le condizioni';

      if (this.errorEl) {
        this.errorEl.textContent = message;
        this.errorEl.hidden = false;
      }

      this.box?.classList.add('has-error');
      this.box?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    hideError() {
      if (this.errorEl) {
        this.errorEl.hidden = true;
      }

      this.box?.classList.remove('has-error');
    }

    blockAddToCart(evt) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      this.showError();
      this.checkbox.focus({ preventScroll: true });
    }

    /**
     * @param {MouseEvent} evt
     */
    handleAddButtonClick(evt) {
      if (!this.requiresConsent()) return;
      this.blockAddToCart(evt);
    }

    /**
     * @param {SubmitEvent} evt
     */
    handleSubmit(evt) {
      if (!this.requiresConsent()) {
        if (this.checkbox.checked) {
          this.hideError();
        }
        return;
      }

      this.blockAddToCart(evt);
    }
  }

  customElements.define('medical-device-consent', MedicalDeviceConsent);
}
